<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 洗选产品日报表 </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">导出</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.startDate" type="date" placeholder="选择日期" class="handle-select mr10" style="width: 130px"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
            </div>
        </div>

        <el-table :data="tableData" border :span-method="objectSpanMethod" show-summary :summary-method="getSummaries" class="table" header-cell-class-name="table-header" :height="tableHeight" ref="table">
            <el-table-column label="晋城公司洗选产品数质量日报表" align="center">
                <el-table-column prop="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column prop="mineName" label="煤矿名称" align="center"></el-table-column>
                <el-table-column prop="indicatorName" label="指标名称" align="center" width="140"></el-table-column>
                <el-table-column label="入选原煤" align="center">
                    <el-table-column prop="selectedCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="selectedCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="selectedCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="入洗原煤" align="center">
                    <el-table-column prop="rawCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="rawCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="rawCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="洗末精煤" align="center">
                    <el-table-column prop="cleanCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="cleanCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="cleanCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="洗块精煤" align="center">
                    <el-table-column prop="lumpCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="lumpCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="lumpCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="中煤" align="center">
                    <el-table-column prop="mediumCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="mediumCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="mediumCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="煤泥" align="center">
                    <el-table-column prop="slurryToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="slurryMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="slurryYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="筛混煤" align="center">
                    <el-table-column prop="sieveCoalToday" label="当日" align="center" width="120"></el-table-column>
                    <el-table-column prop="sieveCoalMonth" label="月累" align="center" width="120"></el-table-column>
                    <el-table-column prop="sieveCoalYear" label="年累" align="center" width="120"></el-table-column>
                </el-table-column>
            </el-table-column>

        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
            },
            provinceArr: [],
            tableHeight: window.innerHeight * 0.75,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                startDate: '',
            },
            tableData: []
        };

    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        }
    },
    created() {
        const start = new Date();
        //start.setTime(start.getTime() + 3600 * 1000 * 24);
        this.query.startDate = start;
        this.getData();
    },
    methods: {
        //自定义方法
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = {};
            let newData = [];
            for (let i = 0; i < data.length; i++) {
                if (data[i].indicatorName == "产量（吨）") {
                    newData[i] = data[i];
                }
            }
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '公司合计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '产量（吨）';
                    return;
                }
                const values = newData.map(item => Number(item[column.property]));
                if (column.label != "序号" && column.label != "煤矿名称" && column.label != "指标名称") {
                    if (!values.every(value => isNaN(value))) {
                        sums[index - 1] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index - 1] = sums[index - 1].toFixed(2); // 保留2位小数
                    }
                }
            });
            return sums;
        },
        mergeCol(id, rowIndex) { // 合并单元格
            // id：属性名
            // rowIndex：行索引值
            var idName = this.tableData[rowIndex][id] // 获取当前单元格的值
            if (rowIndex > 0) { // 判断是不是第一行
                // eslint-disable-next-line eqeqeq
                if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) { // 先判断当前单元格的值是不是和上一行的值相等
                    var i = rowIndex;
                    var num = 0 // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
                    while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
                        if (this.tableData[i][id] === idName) { // 判断循环的单元格的值是不是和当前行的值相等
                            i++ // 如果相等，则索引值加1
                            num++ // 合并的num计数加1
                        } else {
                            i = this.tableData.length // 如果不相等，将索引值设置为table的数组长度，跳出循环
                        }
                    }
                    return {
                        rowspan: num, // 最终将合并的行数返回
                        colspan: 1
                    }
                } else {
                    return {
                        rowspan: 0, // 如果相等，则将rowspan设置为0
                        colspan: 1
                    }
                }
            } else { // 如果是第一行，则直接返回
                let i = rowIndex;
                let num = 0
                while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
                    if (this.tableData[i][id] === idName) {
                        i++
                        num++
                    } else {
                        i = this.tableData.length
                    }
                }
                return {
                    rowspan: num,
                    colspan: 1
                }
            }
        },
        objectSpanMethod({
            row,
            column,
            rowIndex,
            columnIndex
        }) { // 合并单元格
            switch (columnIndex) { // 将列索引作为判断值
                // 通过传递不同的列索引和需要合并的属性名，可以实现不同列的合并
                case 0:
                    return this.mergeCol('index', rowIndex)
                case 1:
                    return this.mergeCol('mineName', rowIndex)
            }
            this.$nextTick(x => {
                if (this.$refs.table.$el) {
                    var current = this.$refs.table.$el
                        .querySelector(".el-table__footer-wrapper")
                        .querySelector(".el-table__footer");
                    var cell = current.rows[0].cells;
                    cell[0].colSpan = "2";
                    cell[0].rowSpan = "1";
                    cell[1].rowSpan = "1";
                    cell[2].rowSpan = "1";
                }
                this.$refs['table'].doLayout();
            })
        },
        getData() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.isAdmin = userInfo.id == 1 ? true : false;
            if (this.query.startDate == null) {
                this.$notify.warning('日期不能为空!!!');
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.startDate, 'yyyy-MM-dd 08:00:00'));
            this.query.loginId = userInfo.loginId;
            this.query.userType = userInfo.userType;
            this.$zybhttp
                .post('WashingProductReport/WashingProductDailyReportData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.tableData = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    '晋城公司洗选产品数质量日报表' + name + '.xlsx'
                );
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        },
    },

};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
